module.exports = __webpack_public_path__ + "static/media/dataPins.865652ef.png";